<template>
	<page>
		<v-container>
			<v-row class="align-content" justify="center" align="center" style="height: 100vh; border-radius: 50%; overflow: hidden;">
				<div class="base-page">
					<v-row align="center" justify="center">
						<v-progress-circular
							indeterminate
							height="30"
							color="primary"
						/>
					</v-row>
					<v-row align="center" justify="center" class="pt-3">
						<div class="primary--text text-h2 font-weight-bold">מיד תועברו לתשלום</div>
					</v-row>
				</div>
			</v-row>
		</v-container>
	</page>
</template>
<script>
import CloseAppLogo from "@/components/CloseAppLogo";
import ProjectModule from "./../store/modules/Project.module";
import { types as authType } from "@/store/modules/Auth.module";

export default {
	name: "LoadingView",
	components: { CloseAppLogo },

	async created() {
		const id = this.$route.query.p;
		if (id) {
			try {
				await this.$store.dispatch(authType.GET);
			} catch (e) {
			}
			const project = await this.$store.dispatch(
				ProjectModule.types.GET,
				{ id, plan: this.$route.query.plan },
			);
			if (project) {
				if (this.$store.getters.isConnected) {
					this.$router.push(`/plans${location.search}`);
				} else {
					this.$router.push({ path: `/welcome${location.search}` });
				}
			}
		}
	},
};
</script>
<style lang="scss" scoped>

.background-wrapper {
	background-color: #905496;
	height: 100%;
}

</style>
